import React from 'react';
import { IconProps } from './types';

export const TheaterIcon: React.FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M1 9V5C1 4.44772 1.44772 4 2 4H6M1 15V19C1 19.5523 1.44772 20 2 20H6M18 4H22C22.5523 4 23 4.44772 23 5V9M18 20H22C22.5523 20 23 19.5523 23 19V15" />
    <rect x="4.75" y="7.75" width="14.5" height="8.5" strokeWidth="1.5" />
  </svg>
);
